export default {"src":"/_next/static/media/Both.869de7f7.gif","height":666,"width":684,"blurWidth":0,"blurHeight":0};